import { render, staticRenderFns } from "./FiltrosBusqueda.vue?vue&type=template&id=21177498&"
import script from "./FiltrosBusqueda.vue?vue&type=script&lang=ts&"
export * from "./FiltrosBusqueda.vue?vue&type=script&lang=ts&"
import style0 from "./FiltrosBusqueda.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports